var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.done)?_c('router-view'):_c('div',{staticClass:"loadings"},[_c('img',{attrs:{"src":_vm.$store.state.shopInfo.logo}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }